import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-inner" }
const _hoisted_3 = { class: "footer-top" }
const _hoisted_4 = { class: "footer-brand" }
const _hoisted_5 = { class: "footer-brand-row" }
const _hoisted_6 = { class: "footer-tagline" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "footer-version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon18plus = _resolveComponent("icon18plus")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "footer-logo-text" }, "jumbada™", -1)),
            _createVNode(_component_icon18plus)
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.jsonData.footerTagline), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-socials" }, [
          _createElementVNode("a", {
            class: "social-btn",
            href: "https://www.linkedin.com/company/jumbada",
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "LinkedIn"
          }, [
            _createElementVNode("span", { class: "social-in" }, "in")
          ])
        ], -1))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footer-divider" }, null, -1)),
      _createElementVNode("div", {
        class: "footer-copy",
        innerHTML: _ctx.jsonData.copyRightMien
      }, null, 8, _hoisted_7),
      _createElementVNode("div", {
        class: "footer-legal",
        innerHTML: _ctx.jsonData.copyRight
      }, null, 8, _hoisted_8),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.buildDate), 1)
    ])
  ]))
}